export default __webpack_public_path__ + "static/media/pricing-image-08.c574eba5.png";